import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import DepartmentForm from './DepartmentForm';

const DepartmentActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const DepartmentCreate = (props: any) => {
  return (
    <Create actions={<DepartmentActions {...props} />} {...props}>
      <DepartmentForm />
    </Create>
  );
};

export default DepartmentCreate;
